// utils/axiosAuth.js
import axios from "axios"
import { BASE_AUTH_URL, BASE_LOGIN_URL } from "../config"

export const axiosAuth = axios.create({
  baseURL: BASE_AUTH_URL,
  withCredentials: true,
})

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })

  failedQueue = []
}

const saveUserWork = () => {
  try {
    // Save current form data or user input
    const currentPath = window.location.pathname
    const formData = {}

    // Save textarea and input values
    const inputs = document.querySelectorAll("input, textarea, select")
    inputs.forEach((input) => {
      if (input.value && input.name) {
        formData[input.name] = input.value
      }
    })

    if (Object.keys(formData).length > 0) {
      localStorage.setItem(
        "unsaved_work",
        JSON.stringify({
          path: currentPath,
          data: formData,
          timestamp: Date.now(),
        }),
      )
    }
  } catch (error) {
    console.error("Failed to save user work:", error)
  }
}


axiosAuth.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalRequest = err.config

    if (err.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // If already refreshing, queue this request
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        })
          .then(() => {
            return axiosAuth(originalRequest)
          })
          .catch((err) => {
            return Promise.reject(err)
          })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const refreshResponse = await axios.get(`${BASE_AUTH_URL}/auth/refresh`, {
          withCredentials: true,
        })

        processQueue(null, refreshResponse.data)
        isRefreshing = false
        return axiosAuth(originalRequest)
      } catch (refreshError) {
        console.error("❌ Refresh token failed:", refreshError)
        processQueue(refreshError, null)
        isRefreshing = false



        const currentUrl = window.location.href
        const encodedRedirect = encodeURIComponent(currentUrl)
        window.location.href = `${BASE_LOGIN_URL}?redirectTo=${encodedRedirect}`

        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(err)
  },
)

